import React, { useCallback } from 'react';
import FormattedNumber, { roundNumber, formatNumber as formatNum } from '../../common/FormattedNumber';

export const useBaseWidget = () => {
    // Returns number which has been divided based on unit.
    const numberWithUnit = useCallback((number, unit) => {
        let num = parseFloat(number);

        if (!isNaN(num)) {
        if (unit) {
            let div = 1;

            switch (unit) {
            case "hundreds":
                div = 100;
                break;
            case "thousands":
                div = 1000;
                break;
            case "millions":
                div = 1000000;
                break;
            case "billions":
                div = 1000000000;
                break;
            }

            return num / div;
        }
        }

        return num;
    }, [])

    // Formats number with unit and precision
    // returns a React element.
    const formatDisplayedNumber = useCallback((number, unit, precision, number_format=null, rollingNumberAnimation=false) => {
        return (<FormattedNumber number={numberWithUnit(number, unit)} round={precision !== undefined ? precision : 2} number_format={number_format} rollingNumberAnimation={rollingNumberAnimation} />);
    }, [])

    // Round number to precision
    // Formats number according to number-format.
    // Returns a string.
    const formatNumber = useCallback((number, unit, precision, number_format) => {
        if (number === undefined || isNaN(parseFloat(number))) return "";
        return `${formatNum(roundNumber(number, precision !== undefined ? precision : 2), number_format)}${unit ? ` ${I18n.t(`number_unit_${unit}`).toLowerCase()}` : ""}`;
    }, [])

    // Returns a rounded number
    const numberWithPrecision = useCallback((number, precision) => {
        let num = parseFloat(number);

        if (!isNaN(num)) {
        return roundNumber(num, precision !== undefined ? precision : 2);
        }

        return number;
    }, [])

    return {
        numberWithUnit,
        formatDisplayedNumber,
        formatNumber,
        numberWithPrecision,
    }
}